module.exports = __webpack_public_path__ + "img/wtmw.7fb5dc1f.png";